module.exports = __webpack_public_path__ + "img/Multiview - Green.384f51d6.png";